/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceInventoryLookup {
    getFixupPrototypeFunction() { return ServiceResourceInventoryLookup.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceInventoryLookup>): ServiceResourceInventoryLookup {
        let obj = Object.assign(new ServiceResourceInventoryLookup(), model);
        ServiceResourceInventoryLookup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceInventoryLookup>): ServiceResourceInventoryLookup {
        if (!model) return null;
        return ServiceResourceInventoryLookup.newInstance(<ServiceResourceInventoryLookup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceInventoryLookup) {
        if (!obj) return;

        models.ServiceResourceInventoryLookup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceInventoryLookup): boolean {
        Object.setPrototypeOf(obj, ServiceResourceInventoryLookup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the resource
     */
    corestack_resource_id: string;

    /**
     * ID of the service account
     */
    service_account_id: string;

}
